module.exports = __webpack_public_path__ + "static/media/status-off.643aa658.svg";